import React from 'react';

import styles from '../../assets/styles/Onboarding/Onboarding.module.scss';
import MimaLogo from '../../assets/img/mima-logo.png';
import { useMediaQuery } from 'react-responsive';
import { useNavigate } from 'react-router-dom';
import constant from '../../utils/constant';

const OnboardLeft = props => {
	const isBelow450 = useMediaQuery({
		query: '(max-width: 450px)',
	});

	const navigate = useNavigate();

	const goToLanding = () => {
		navigate(constant.Routes.Home);
	};

	return (
		<div className={styles.left}>
			<img src={MimaLogo} className={styles.logo} onClick={goToLanding} />
			{!isBelow450 && (
				<div>
					<h2 className={styles.left__h2}>
						Thank you for Signing up with Mima.
					</h2>
					<p className={styles.left__p}>
						You are just few clicks away from <br />a fully activated account.
					</p>
				</div>
			)}

			<div className={styles.crumbs}>
				<div className={props.crumbs1}></div>
				<div className={props.crumbs2}></div>
				<div className={props.crumbs3}></div>
			</div>
		</div>
	);
};

export default OnboardLeft;
